/* eslint-disabled */

export default class CompanyExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
